import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  children: ReactNode;
  hint?: string;
  className?: string;
}

/** Label + control stack. */
export function Field({ label, children, hint, className = "" }: FieldProps) {
  return (
    <div className={`flex flex-1 flex-col gap-1.5 ${className}`}>
      <label className="font-display text-[10px] font-semibold uppercase tracking-[0.14em] text-on-surface-variant">
        {label}
      </label>
      {children}
      {hint ? <span className="font-body text-[10px] text-outline">{hint}</span> : null}
    </div>
  );
}

/** Uppercase section heading with a hairline underline. */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="mt-3 border-b border-outline-variant/30 pb-1 font-display text-[10px] font-semibold uppercase tracking-[0.14em] text-outline">
      {children}
    </div>
  );
}

export function Divider() {
  return <hr className="border-outline-variant/20" />;
}
